import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { BerLayoutComponent } from './ber-layout/ber-layout.component';
import { BerLetiltasComponent } from './letiltas/letiltas.component';
import { UgyfelekComponent } from './ugyfelek/ugyfelek.component';
import { AlkalmazottakComponent } from './alkalmazottak/alkalmazottak.component';
import { SzamfejtesComponent } from './szamfejtes/szamfejtes.component';
import { ListakComponent } from './listak/listak.component';
import { AtalanyComponent } from './atalany/atalany.component';
import { BeallitasokComponent } from './beallitasok/beallitasok.component';
import { BerFomenuComponent } from './fomenu/fomenu.component';
import { BerTorzsekComponent } from './torzsek/torzsek.component';
import { BerTetelekPanelComponent } from './tetelek-panel/tetelek-panel.component';
import { BerElectraPanelComponent } from './electra-panel/electra-panel.component';
import { ProfilMenuComponent } from '../components/profil-menu/profil-menu.component';
import { KapcsolatValasztoComponent } from '../components/kapcsolat-valaszto/kapcsolat-valaszto.component';
import { UgyfelkorBeallitasComponent } from '../components/ugyfelkor-beallitas/ugyfelkor-beallitas.component';
import { SzerkZarSavComponent } from '../components/szerk-zar/szerk-zar-sav.component';

// BER – Bérszámfejtő feature-modul. Saját IonicModule importtal (mint a NaploModule),
// a routing az app-routing.module-ban eager komponens-referenciákkal tölti be.
@NgModule({
  declarations: [BerLetiltasComponent, BerLayoutComponent, BerFomenuComponent, BerTorzsekComponent, UgyfelekComponent, AlkalmazottakComponent, SzamfejtesComponent, ListakComponent, AtalanyComponent, BeallitasokComponent],
  imports: [CommonModule, FormsModule, RouterModule, IonicModule, ProfilMenuComponent, BerTetelekPanelComponent, BerElectraPanelComponent, KapcsolatValasztoComponent, UgyfelkorBeallitasComponent, SzerkZarSavComponent],
  exports: [BerLetiltasComponent, BerLayoutComponent, BerFomenuComponent, BerTorzsekComponent, UgyfelekComponent, AlkalmazottakComponent, SzamfejtesComponent, ListakComponent, AtalanyComponent, BeallitasokComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BerModule {}
